import React, { StatelessComponent } from 'react';
import b from 'b_';

import Rect from '@components/rect';

import './themes.css';

interface ThemesStubProps {
    itemsCount: number;
}

const class_ = b.with('themes-stub');

const ThemesStub: StatelessComponent<ThemesStubProps> = ({ itemsCount }) => {
    const items = Array(itemsCount).fill(0);

    return (
        <ul className={class_()}>
            {items.map((_: any, index: number) => (
                <li key={index}>
                    <Rect width={300} height={24} />
                </li>
            ))}
        </ul>
    );
};

export default ThemesStub;
